import api from 'ApiConfig';

const courseService = {
  createCourse: async (data) => {
    return api.post('/admin/create-course', data);
  },
  updateCourse: async (courseId, data) => {
    return api.post('/admin/update-course', { ...data, courseId });
  },
  deleteCourse: async (courseId) => {
    return api.post('/admin/delete-course', { courseId });
  },

  getAllCourses: async (selectedBranch) => {
    return api.post('/admin/get-all-course', { selectedBranch });
  },

  getCourseBatchInfo: async (data) => {
    return api.post('/admin/get-batch-course', data);
  },
  // addBatch: async (data) => {
  //   return api.post('/admin/create-new-batch', data);
  // },
  addBatch: async (data) => {
    return api.post('/admin/create-new-batch', {
      ...data,
      selectedBranch: data.selectedBranch,
    });
  },
  getBatchesByCourse: async (courseId, selectedBranch) => {
    return api.post('/admin/get-course-by-courseId', {
      courseId,
      selectedBranch,
    });
  },
  getBatchesByCourseStructure: async (
    courseId,
    batchStructureId,
    selectedBranch
  ) => {
    return api.post('/admin/get-batches-by-course-structure', {
      courseId,
      batchStructureId,
      selectedBranch,
    });
  },

  editBatch: async (data) => {
    return api.post('/admin/update-batch', data);
  },
  deleteBatchById: async (batchId) => {
    return api.post(`/admin/delete-batch-by-id/${batchId}`);
  },

  getCourses: async (selectedBranch) => {
    return api.post('/admin/get-courses', { selectedBranch });
  },

  getLatestBatch: async (batchStructureId, branches) => {
    return api.get(`/admin/latest-batch/${batchStructureId}`, {
      params: { branches },
    });
  },

  getAllDepartments: async () => {
    return api.get('/admin/get-all-departments');
  },

  getCoursesByDepartment: async (departmentId, selectedBranch) =>
    api.post('/admin/get-courses-by-department', {
      departmentId,
      selectedBranch,
    }),
};
export default courseService;
